import config from 'config';
import backendConfig from './backendConfig';

function ssoIsInvalid(response) {
  return response.status == 401
    && response.body.errors
    && response.body.errors.sso === 'invalid';
}

function redirectToAnonymousAuth() {
  const refUrl = window.location.search.replace(/^\?/, '&') + window.location.hash;
  backendConfig.get().then(({backendUrl}) => {
    const redirectUrl =
      backendUrl + config.backend.feeds.anonymousAuth +
      '?refUrl=' +
      encodeURIComponent(refUrl) +
      '&hostDomain=' +
      window.location.hostname;

    window.location = redirectUrl;
  });
}

export default {
  ssoIsInvalid,
  redirectToAnonymousAuth,
};



// WEBPACK FOOTER //
// ./src/utils/backend.js